/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2024 (c) Daniel Littfinski, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2025-2026 (c) Nico Brandt, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React, { useEffect } from 'react';
import { connect, useDispatch } from 'react-redux';
import Softwares from './Software';
import NewSoftware from './_softwareExample.json';
import { SoftwareActions } from './SoftwareActions';
import { ISoftwaresState } from './SoftwareReducer';
import { RootState } from '../reducer';
import { AllowedRoles, useAuth } from 'Contexts/Auth';
import { ICompaniesState } from 'CompanyData/CompanyReducer';
import { CompanyDataActions } from 'CompanyData/CompanyDataActions';
import { IUsersState } from 'UserList/UsersReducer';
import { UserActions } from 'UserList/UserActions';

const newSoftware = NewSoftware;

interface ISoftwareList {
  sw: ISoftwaresState;
  cp: ICompaniesState;
  users: IUsersState;
}

const SoftwareList = ({ sw, cp, users }: ISoftwareList) => {
  const dispatch = useDispatch();
  const auth = useAuth();
  const isAdminOrSuperAdmin = auth.user?.Roles?.some((r) => r === 'SuperAdmin' || r === 'Admin') ?? false;

  console.log('SoftwareLists.tsx: ' + isAdminOrSuperAdmin);
  useEffect(() => {
    SoftwareActions.QuerySoftwares()(dispatch);
    CompanyDataActions.QueryCompanys()(dispatch);
    if (isAdminOrSuperAdmin) {
      UserActions.QueryUsers()(dispatch);
    }
  }, [dispatch, isAdminOrSuperAdmin]);
  const keys = Object.keys(sw.softwares).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));

  return (
    <div>
      <AllowedRoles roles={['SuperAdmin', 'Admin', 'CompanyMember']}>
        <ul>
          {keys.map((key) => {
            return (
              <Softwares
                key={key}
                sw={sw.softwares[key]}
                isAdd={false}
                existingSoftwareIds={sw.softwareIds}
                existingCompanies={cp.Companies}
                existingUsers={Object.values(users.Users)}
              ></Softwares>
            );
          })}
        </ul>
      </AllowedRoles>
      <AllowedRoles roles={['SuperAdmin', 'Admin']}>
        <ul>
          <Softwares
            key="New"
            sw={newSoftware}
            isAdd={true}
            existingSoftwareIds={sw.softwareIds}
            existingCompanies={cp.Companies}
            existingUsers={Object.values(users.Users)}
          ></Softwares>
        </ul>
      </AllowedRoles>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    sw: state.softwares,
    cp: state.companies,
    users: state.users,
  };
};

export default connect(mapStateToProps)(SoftwareList);
